import "./App.css";
import { useState } from "react";
import { BrowserRouter, Route, RouteObject, Routes } from "react-router-dom";
import { usePromiseEffect } from "./helpers/promiseEffect";
import { cognitoUserInfo } from "./helpers/userHelper";
import Layout from "./cross/Layout";
import { filterRoutes } from "./helpers/appHelpers";

const App = () => {
  const [routes, setRoutes] = useState<RouteObject[]>([]);

  usePromiseEffect(async () => {
    let currUser = await cognitoUserInfo();
    const routesUser = filterRoutes(currUser);
    setRoutes(routesUser);
  }, []);

  return (
    <Layout>
      <BrowserRouter>
        {routes.length > 0 && (
          <Routes>
            {routes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Routes>
        )}
      </BrowserRouter>
    </Layout>
  );
};

export default App;
